import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Form, Field} from 'react-final-form';
import { FloatLabel } from 'primereact/floatlabel';
import { classNames } from 'primereact/utils';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import countries from '../data/country.json'

const PersonalIdentity = ({ familyMember, sfd, labels, calculateAge, isFormFieldValid, getFormErrorMessage }) => {
    return <Form
        onSubmit={(data, form) => {
            for (let key in data)
                familyMember[key] = data[key];
            const localDate = new Date(familyMember.birthDate);
            familyMember.birthDate = new Date(Date.UTC(
                localDate.getFullYear(),
                localDate.getMonth(),
                localDate.getDate()
            )); // Keep only YYYY-MM-DD
            familyMember.phone = "+" + familyMember.phoneCode + " " + familyMember.phone;
            delete familyMember.phoneCode;
            familyMember.currentStep++;
            sfd(familyMember);
        }}
        initialValues={familyMember.phone ?
            { ...familyMember, phoneCode: familyMember.phone.split(' ')[0].replaceAll('+', ''), phone: familyMember.phone.split(' ')[1] } :
            familyMember}
        validate={(data) => {
            let error = {};
            let requiredFields = ["name", "surname", "birthDate", "gender"];
            if (familyMember.personID == 0) {
                requiredFields.push("email");
                requiredFields.push("phone");
                requiredFields.push("phoneCode");
            }
            for (let f of requiredFields)
                if (!data[f] && data[f] !== false)
                    error[f] = labels['This field is required.'];

            if (data["email"] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data["email"]))
                error["email"] = labels['Invalid email address'];
            if (data["birthDate"] && calculateAge(data["birthDate"]) < 18 && familyMember.personID === 0)
                error["birthDate"] = labels['The first pilgrim must be at least 18'];
            return error;
        }
        }
        render={({ handleSubmit }) => (<>

            <div className="grid ui-fluid">
                <div className="col-12 md:col-6">
                    <Field name={"name"}
                        render={({ input, meta }) => (<div className="field">
                            <FloatLabel>
                                <InputText
                                    type="text"
                                    {...input}
                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                />
                                <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                    {labels.name}
                                </label>
                            </FloatLabel>
                            {getFormErrorMessage(meta)}
                        </div>)} />
                </div>
                <div className="col-12 md:col-6">
                    <Field name={"surname"}
                        render={({ input, meta }) => (<div className="field">
                            <FloatLabel>
                                <InputText
                                    type="text"
                                    {...input}
                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                />
                                <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                    {labels.surname}
                                </label>
                            </FloatLabel>
                            {getFormErrorMessage(meta)}
                        </div>)} />
                </div>
            </div>
            <div className="grid ui-fluid">
                <div className="col-12 md:col-6">
                    <Field name={"birthDate"}
                        render={({ input, meta }) => (<div className="field">
                            <FloatLabel>
                                <Calendar
                                    {...input}
                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                    dateFormat="dd-mm-yy"
                                    showIcon
                                />
                                <label
                                    className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                    {labels.birthDate}
                                </label>
                            </FloatLabel>
                            {getFormErrorMessage(meta)}
                        </div>)} />
                </div>
                <div className="col-12 md:col-6">
                    <Field name={"gender"}
                        render={({ input, meta }) => (<div className="field">
                            <FloatLabel>
                                <SelectButton
                                    {...input}
                                    className={"genderselectbutton" + classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                    options={[{
                                        'label': '‍♂️ ' + labels.male,
                                        'value': 'M'
                                    }, {
                                        'label': '♀️ ' + labels.female,
                                        'value': 'F'
                                    }
                                    ]}
                                />
                            </FloatLabel>
                            {getFormErrorMessage(meta)}
                        </div>)} />
                </div>
            </div>
            <div className="grid ui-fluid">
                <div className="col-12 md:col-6">
                    <Field name={"email"}
                        keyfilter="email"
                        render={({ input, meta }) => (<div className="field">
                            <FloatLabel>
                                <InputText
                                    {...input}
                                    type="email"
                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                />
                                <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                    {labels.email}
                                </label>
                            </FloatLabel>
                            {getFormErrorMessage(meta)}
                        </div>)} />

                </div>
                <div className="col-12 md:col-6">
                    <div className="row">
                        <div className="field p-inputgroup flex-row">
                            <Field name={"phoneCode"}
                                render={({ input, meta }) => (
                                    <>
                                        <div className="flex-column">
                                            <FloatLabel >
                                                <Dropdown
                                                    scrollHeight="300px"
                                                    style={{ width: '130px' }}
                                                    {...input}
                                                    optionLabel="name"
                                                    optionValue="value"
                                                    filter
                                                    options={Object.entries(countries).map(([code, country]) => { return { 'name': (country.emoji + " +" + country.phoneFormat.code), 'value': country.phoneFormat.code } })}
                                                    placeholder='Code'
                                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                                />
                                            </FloatLabel>
                                            {getFormErrorMessage(meta)}
                                        </div>
                                    </>
                                )} />
                            <Field name={"phone"}
                                render={({ input, meta }) => (
                                    <div className="flex-column" >
                                        <FloatLabel >
                                            <InputText
                                                style={{ width: '130px' }}
                                                type="tel"
                                                {...input}
                                                className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                                keyfilter="num"
                                            />
                                            <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                                {labels.phone}
                                            </label>
                                        </FloatLabel>
                                        {getFormErrorMessage(meta)}
                                    </div>
                                )} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex py-4">
                <Button
                    type="button"
                    label={labels.next}
                    icon="pi pi-arrow-right"
                    iconPos="right"
                    onClick={handleSubmit} />
            </div>

        </>)} />
}
export default PersonalIdentity;